/**
 * Keeps the "Select Frequency" widget prices in sync with the selected
 * quantity tier. Verified against the store's discount engine: the
 * "Buy 2+/4+" automatic discounts stack on top of the selling-plan
 * (subscription) price, so both rows always show the tier-discounted
 * per-unit price, e.g. "$80.10 each".
 */
(function () {
  'use strict';

  var QTY_BUTTON = '[data-quantity-button]';

  function formatMoney(cents) {
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    return '$' + (cents / 100).toFixed(2) + ' ' + currency;
  }

  function init(container) {
    var widget = container.querySelector('[data-product-subscription-options]');
    if (!widget || !container.querySelector(QTY_BUTTON)) return;

    /**
     * Raw variant price in cents. The tiles' data-variant-price can't be
     * used: the theme rebases it on the checked purchase-type radio, so it
     * already includes the subscription discount when autodeliver is on.
     */
    var onetimeRadio = widget.querySelector('[data-recharge-checkbox][value="onetime"]');
    var variantPrice = onetimeRadio
      ? Number(onetimeRadio.getAttribute('data-recharge-price'))
      : 0;

    /**
     * Pricing block inside the add-to-bag button. The bundle replaces its
     * innerHTML wholesale (new spans without data attributes), so cache the
     * container and re-query the price span on every pass.
     */
    var addBtnPricing = container.querySelector(
      '[data-product-form-add-main] [data-product-pricing]'
    );

    /**
     * Only writes when the text differs, so the MutationObserver below can
     * call apply() without looping.
     */
    function writeAll(selector, cents) {
      widget.querySelectorAll(selector).forEach(function (el) {
        var text = formatMoney(cents) + ' each';
        if (el.innerText.trim() !== text) el.innerText = text;
      });
    }

    function apply() {
      var selected = container.querySelector(QTY_BUTTON + '.is-selected');
      if (!selected || !variantPrice) return;

      var tierPct = Number(selected.getAttribute('data-discount-value')) || 0;

      var discountEl = widget.querySelector('[data-recharge-discount]');
      var subPct = discountEl
        ? Number(discountEl.getAttribute('data-recharge-discount')) || 0
        : 0;

      var onetime = Math.round(variantPrice * (1 - tierPct / 100));
      var subscribe = Math.round(variantPrice * (1 - subPct) * (1 - tierPct / 100));

      writeAll('[data-onetime-price]', onetime);
      writeAll('[data-discount-price]', subscribe);

      /**
       * The bundle discounts the line total (75.65 x 2 x 0.9 = 136.17), but
       * checkout rounds the per-unit price first (75.65 x 0.9 = 68.085 ->
       * 68.09 -> 136.18), so mirror checkout: rounded per-unit x quantity.
       */
      var addBtnMoney = addBtnPricing && addBtnPricing.querySelector('.o-pricing__price');
      if (addBtnMoney) {
        var qty = Number(selected.getAttribute('value')) || 1;
        var autodeliver = widget.querySelector(
          '[data-recharge-checkbox][value="autodeliver"]'
        );
        var perUnit = autodeliver && autodeliver.checked ? subscribe : onetime;
        var totalText = '$' + ((perUnit * qty) / 100).toFixed(2);
        if (addBtnMoney.innerText.trim() !== totalText) {
          addBtnMoney.innerText = totalText;
        }
      }
    }

    /**
     * The theme bundle rewrites the same price nodes (with single-unit
     * values) inside its own handlers for these events, so defer a tick
     * to run after it.
     */
    function applyLater() {
      window.setTimeout(apply, 0);
    }

    container.addEventListener('onQtyChange', applyLater);
    container.addEventListener('onVariantChange', function (event) {
      var newVariant = event.detail && event.detail.newVariant;
      if (newVariant && newVariant.price) variantPrice = Number(newVariant.price);
      applyLater();
    });
    container.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest(QTY_BUTTON)) applyLater();
    });
    /* Switching between one-time and subscribe changes the button total. */
    container.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('[data-recharge-checkbox]')) {
        applyLater();
      }
    });

    /**
     * The theme bundle also rewrites these nodes outside the events above
     * (e.g. during its own late init on page load), which would strip the
     * "each" suffix. Re-apply whenever anyone else touches them; writeAll's
     * same-text guard keeps this from looping.
     */
    var observer = new MutationObserver(apply);
    widget
      .querySelectorAll('[data-onetime-price], [data-discount-price]')
      .forEach(function (el) {
        observer.observe(el, { childList: true, characterData: true, subtree: true });
      });
    if (addBtnPricing) {
      observer.observe(addBtnPricing, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-product-main]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
